import React from "react";
import { withLocalize, Translate } from "react-localize-redux";

function ClinicItem(props) {
  let langCode = "en";
  if (props.activeLanguage !== undefined) {
    langCode = props.activeLanguage.code;
  }
  return (
    <div class="col-md-6">
      <div class={`card mb-4 ${props.active == "0" ? "clinic-bg-inactive" : ""} card-queue`} data-q_id="1">
        <input type="hidden" value="" class="qData" data-id="1" />
        <div class="card-body">
          <div class="media">
            <img
              class={`${langCode == "ar" ? "ml-3" : "mr-3"}`}
              
              
              style={{ width: "64px" }}
              src={`../assets/img/clinic/${props.active_doctor.speciality_id}.png`}
              alt={langCode == "ar"
              ? props.active_doctor.speciality_ar
              : props.active_doctor.speciality_en}
            />
            <div class="media-body">
              <h3 class="mt-0">
                {langCode == "ar"
                  ? props.active_doctor.name_ar
                  : props.active_doctor.name_en}
              </h3>
              <h5>
              {langCode == "ar"
              ? props.active_doctor.speciality_ar
              : props.active_doctor.speciality_en}
              </h5>
              
            </div>
          </div>

          <p class="card-text" />

          <div class="d-flex justify-content-between  align-items-right">
            <span class="text-muted">
              <strong>Waiting </strong>{" "}
              <span class="badge badge-warning">
                {props.next_reservations.length}
              </span>{" "}
            </span>
            {props.current_ticket !== null && (
              <span class="text-muted">
                <strong>Serving Now</strong>{" "}
                <span class="badge badge-warning">
                  {props.current_ticket.ticket_prefix +
                    props.current_ticket.ticket_num}
                </span>{" "}
              </span>
            )}
            <div class="btn-group">
              {props.active_online == "0" && props.active == "1" ? 
                <button type="button" class="btn btn-sm btn-inverse" disabled><Translate id="general.BookinginClinicOnly"/></button>
                :
                <div></div>
               }
              {props.active_online == "1" && props.active == "1" ? 
               <button type="button" class="btn btn-sm btn-primary"><Translate id="general.BookTicket"/></button>
               :
               <div></div>
               }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default withLocalize(ClinicItem);



// WEBPACK FOOTER //
// ./src/pages/Clinic/ClinicItem.js